import { render, staticRenderFns } from "./Document-search.vue?vue&type=template&id=eba3c066&scoped=true"
import script from "./Document-search.vue?vue&type=script&lang=js"
export * from "./Document-search.vue?vue&type=script&lang=js"
import style0 from "./Document-search.vue?vue&type=style&index=0&id=eba3c066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba3c066",
  null
  
)

export default component.exports